// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'
import md5 from 'blueimp-md5'

/**
 * @apiName 用户登录
 */
export function login(username, password, code) {
  return request({
    url: '/admin/v1/vehicle/user/token/create',
    method: 'post',
    data: {
      username,
      password: md5(password),
      smsCode: code,
    },
  })
}

/**
 * @apiName 通过 token 置换用户信息
 */
export function getInfoByToken() {
  return request({
    url: '/admin/v1/vehicle/user/token/currentUser',
    method: 'post',
    data: {},
  })
}


/**
 * @apiName 刷新 token
 */
export function refreshToken() {
  return request({
    url: '/admin/v1/vehicle/manage/token/refresh',
    method: 'post',
    data: {},
  })
}

/**
 * @apiName 退出登录
 */
export function logout(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/token/release',
    method: 'post',
    data,
  })
}

/**
 * 切换租户
 */
export function switchCompany(companyId) {
  return request({
    url: '/admin/v1/vehicle/user/token/switch',
    method: 'post',
    data: {
      switchTo: companyId,
    },
  })
}

/**
 * 租户列表
 */
export function companyList() {
  return request({
    url: '/admin/v1/vehicle/user/token/switchList',
    method: 'post',
    data: {},
  })
}

/**
 * @apiname 商城登录授权
 * @param {string} phone 手机号
 * @param {number} companyId 公司ID
 */
export function purchaseMallLogIn(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/mall/logIn',
    method: 'post',
    data,
  })
}

/**
 * @apiname 商城退出登录
 * @param {string} phone 手机号
 * @param {number} companyId 公司ID
 */
export function purchaseMallLogOut(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/mall/logOut',
    method: 'post',
    data,
  })
}
